import { Link } from "react-router-dom";
import { services } from "@/mocks/home";

export default function Services() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-widest text-primary-600 font-semibold">Our services</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              One carrier stack, every wholesale use case.
            </h2>
            <p className="mt-4 text-foreground-700 text-base md:text-lg leading-relaxed">
              Termination, origination, trunking, and dialer-ready routes — engineered together so your traffic never has to compromise between quality and price.
            </p>
          </div>
          <Link
            to="/solutions/wholesale-voice-termination"
            className="inline-flex items-center gap-2 text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer whitespace-nowrap"
          >
            View all solutions
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => (
            <Link
              key={s.title}
              to={s.to}
              className="group relative bg-background-50 border border-background-200 hover:border-primary-400 rounded-xl p-6 transition-all cursor-pointer"
            >
              <div className="flex items-start justify-between mb-5">
                <span className="w-12 h-12 rounded-lg bg-primary-100 group-hover:bg-primary-500 group-hover:text-background-50 text-primary-700 flex items-center justify-center transition-colors">
                  <i className={`${s.icon} text-xl w-6 h-6 flex items-center justify-center`} />
                </span>
                <span className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                  {s.tag}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 font-heading">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              <div className="mt-5 flex items-center text-sm font-semibold text-primary-600 group-hover:gap-2 gap-1 transition-all">
                Learn more
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}